// 表情符號 紀錄顯示
import Image from 'next/image';

const NewsEmojiDisplay = ({ emojis, onClickEmoji, onThumb }) => {
    // 有按讚數的表情
    const isThumbedEmojis = emojis?.filter((v) => v?.count > 0 || v?.isThumbed === 1);

    return (
        <div
            id="emoji-target"
            className="py-[22px] flex items-center gap-x-[20px] gap-y-[15px] flex-wrap"
        >
            {isThumbedEmojis?.map((emoji, i) => (
                <button
                    key={emoji?.img + i}
                    onClick={() => {
                        if (emoji?.id === 'thumb') {
                            onThumb(emoji?.id);
                        } else {
                            onClickEmoji(emoji?.id);
                        }
                    }}
                    className="flex items-center gap-x-[6px] text-btn2 text-purple7"
                >
                    <Image width={20} height={20} src={emoji?.img} alt="emoji" />
                    {emoji && (emoji?.count > 0 || emoji?.isThumbed === 1) && (
                        <span className="tabular-nums">{emoji?.count || 1}</span>
                    )}
                </button>
            ))}
        </div>
    );
};

export default NewsEmojiDisplay;
